module.exports = __webpack_public_path__ + "static/media/ic-streetads.72b39fc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-streetads.svg
// module id = 443
// module chunks = 0